import React, { useCallback, useEffect, useState } from "react";
import CardTable from "../../../components/AdminTable/CardTable";
import { FaEdit, FaTrashAlt, FaCog } from "react-icons/fa";
import { IoIosArrowDown } from "react-icons/io";
import { Link } from "react-router-dom";
import axios from "axios";
import { apiKey } from "../../../config/config";
import { toast } from "react-toastify";

function IngredientCategory() {
  const user = JSON.parse(localStorage.getItem("rms-admin"));
  const [pageLoading, setPageLoading] = useState(true);
  const [error, setError] = useState(false);
  // const navigate = useNavigate();
  const [columns] = useState([
    {
      header: "SN",
      cell: row => row.row.index + 1
    },
    {
      header: "Category Name",
      accessorKey: "category_name",
    },
    {
      header: "Description",
      accessorKey: "description",
    },
    {
      header: "Added By",
      // accessorKey: "added_by",
      cell: (row) => row.row.original.user.name,
    },
    {
      header: "Actions",
      // accessorKey: "SN",
      cell: (row) => (
        <ActionDropdown
          id={row.row.original.id}
          user={user}
          refetchData={fetchData}
        />
      ),
    },
  ]);

  const [data, setData] = useState([]);

  const fetchData = useCallback(() => {
    axios
      .get(`${apiKey}/api/rms/admin/ingredientCategories`, {
        headers: {
          Authorization: `Bearer ${user?.token}`,
        },
        params: {
          outletId: user?.user.outlet_id
        }
      })
      .then((res) => {
        setData(res.data);
      })
      .catch((err) => {
        setError("Cannot load data");
      })
      .finally(() => {
        setPageLoading(false);
      });
  }, [user?.token, user?.user.outlet_id]);

  useEffect(() => {
    setPageLoading(true);
    fetchData();
  }, [fetchData, user.token]);

  const [buttonData] = useState([
    {
      buttonText: "Add Ingredient Category",
      path: "addEditIngredientCategory",
    },
  ]);
  return (
    <main className="relative">
      <CardTable
        data={data}
        error={error}
        columns={columns}
        heading={"Ingredient Categories"}
        buttonData={buttonData}
      />
      {pageLoading && (
        <div className="absolute top-0 left-0 w-full h-full grid place-items-center">
          <img src="/assets/gif/dash2.gif" alt="" />
        </div>
      )}
    </main>
  );
}

function ActionDropdown({ id, user, refetchData }) {
  const [showDropdown, setShowDropDown] = useState(false);
  const [showDelModal, setShowDelModal] = useState(false);

  const handleDelete = () => {
    axios
      .delete(`${apiKey}/api/rms/admin/ingredientCategories/${id}`, {
        headers: {
          Authorization: `Bearer ${user?.token}`,
        },
      })
      .then((res) => {
        toast.success("Success", {
          position: "bottom-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
        refetchData(); // Refetch data after successful delete
        setShowDelModal(false);
        setShowDropDown(false);
      })
      .catch((err) => {
        toast.error(err.response.data.message, {
          position: "bottom-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
      });
  };
  return (
    <>
      <div className="relative">
        <button
          className="text-blueGray-500 px-3 flex items-center justify-between gap-1 border rounded-full"
          onClick={() => setShowDropDown(!showDropdown)}
        >
          <FaCog className="text-[#774d96]" />
          <IoIosArrowDown className="text-[#774d96]" />
        </button>
        <div
          className={
            (showDropdown ? "block " : "hidden ") +
            "absolute top-4 left-0 -translate-x-[75%] bg-white text-base z-10 float-left py-2 list-none text-left rounded shadow-lg min-w-40"
          }
        >
          <Link
            to={`addEditIngredientCategory/${id}`}
            className={
              "text-sm py-2 px-4 font-normal flex items-center gap-4 w-full whitespace-nowrap bg-transparent text-blueGray-700"
            }
          >
            <FaEdit />
            <p> Edit </p>
          </Link>
          <button
            onClick={() => setShowDelModal(true)}
            className={
              "text-sm py-2 px-4 font-normal flex items-center gap-4 w-full whitespace-nowrap bg-transparent text-blueGray-700"
            }
          >
            <FaTrashAlt />
            <p> Delete </p>
          </button>
        </div>
      </div>
      {showDelModal && (
        <div
          className="w-full h-screen overflow-y-auto grid place-items-center fixed top-0 left-0 bg-black bg-opacity-50 backdrop-blur-md p-4 z-10"
          onClick={() => setShowDelModal(false)}
        >
          <div
            className="p-4 rounded-lg bg-white max-w-md w-full space-y-4"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="space-y-4">
              <h1 className="text-[#774d96] font-semibold text-xl text-center">
                Alert!
              </h1>
              <p className="text-center text-gray-700">Are you sure?</p>
            </div>
            <div className="flex justify-center gap-4">
              <button
                className="bg-[#7B20C7] text-white font-bold text-sm px-4 py-1 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150 text-center"
                onClick={() => setShowDelModal(false)}
              >
                No
              </button>
              <button
                onClick={handleDelete}
                className="bg-[#7B20C7] text-white font-bold text-sm px-4 py-1 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150 text-center"
              >
                Yes
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default IngredientCategory;
